<a (click)="goTo()">
  <div class="header">
    <i class="icon {{fileIconType}}" *ngIf="isFile()"></i>
    <span class="type-info text-uppercase" *ngIf="!isFile()">{{data.source}}</span>
  </div>
  <div class="title-container">
    <span class="sub-info">{{data.status}}</span>
    <span class="title" title="{{data.displayName}}">
      {{ data.displayName}}
    </span>
  </div>
  <div class="file-info" *ngIf="isFile()">
    <div class="sub-info text-uppercase"><strong>ADDED: </strong>{{data.createdTime | date:'MMM dd, yyyy'}}</div>
    <!-- <div class="sub-info text-uppercase"><strong>BY: </strong>{{data.author.name}}</div> -->
  </div>
  <div class="sub-info text-uppercase" *ngIf="!isFile()"><strong>{{getFileCount()}}</strong></div>
</a>
<app-asset-action
  [asset]="data"
  [status]="hoverState"
  [type]="'tile'"
  class="file-action"
  (setThumbnail)="onSetThumbnail($event)"
  *ngIf="isFile() && !showDelete">
</app-asset-action>

<app-asset-delete
  [asset]="data"
  [status]="hoverState"
  (delete)="onDelete($event)"
  class="file-action"
  *ngIf="isFile() && showDelete">
</app-asset-delete>
